import { NamedEntity } from '@shared';
import { environment } from 'src/environments/environment';

const modifierCodesFeatureEnabled = environment.modifierCodesFeatureEnabled;

export const upchargeProductType = new NamedEntity('upcharge', 'Upsizes');
export const substitutionProductType = new NamedEntity(
  'substitution',
  'Substitutions',
);
export const modifierProductType = new NamedEntity('modifier', 'Modifiers (Add)');
export const modifierCodesProductType = new NamedEntity(
  'modifiercodes',
  'Modifiers (Options)',
);
export const comboProductType = new NamedEntity('combo', 'Combo');
export const kidMealProductType = new NamedEntity('kidmeal', 'Kids Meal');
export const aLaCarteProductType = new NamedEntity('aLaCarte', 'A La Carte');
export const dmbProductType = new NamedEntity('dmb', 'DMB');
export const promoProductType = new NamedEntity('promo', 'Promos');
export const othersProductType = new NamedEntity('others', 'Others');
export const noProduct = new NamedEntity('na', 'N/A');
export const allProductType = new NamedEntity('all', 'All');
export const ltoProductType = new NamedEntity('lto', 'New LTO(s)');

export const pricingProductTypes: NamedEntity[] = [
  aLaCarteProductType,
  comboProductType,
  upchargeProductType,
  substitutionProductType,
  modifierProductType,
  ...(modifierCodesFeatureEnabled ? [modifierCodesProductType] : []),
  dmbProductType,
  promoProductType,
  kidMealProductType,
  othersProductType,
  ltoProductType,
];

export const availabilityProductTypes: NamedEntity[] = [
  allProductType,
  aLaCarteProductType,
  comboProductType,
  kidMealProductType,
  upchargeProductType,
  substitutionProductType,
  modifierProductType,
  dmbProductType,
  promoProductType,
  othersProductType,
];

export const itemProductTypes: NamedEntity[] = [
  aLaCarteProductType,
  comboProductType,
  noProduct,
];

export type ProductTypeId = NamedEntity['id'];

export const AvailabilityAccessByProductType: Map<string, string> = new Map<
  string,
  string
>([
  ['aLaCarte', 'write'],
  ['combo', 'write'],
  ['modifier', 'write'],
  ['substitution', 'write'],
  ['upcharge', 'write'],
  ['dmb', 'read'],
  ['promo', 'read'],
  ['others', 'write'],
  ['all', 'write'],
]);

export const newFeatures = [modifierCodesProductType.id];